var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMiddle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#5C5F62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69472 10.3867L15.6155 10.3867C15.9983 10.3867 16.3086 10.0764 16.3086 9.69366C16.3086 9.3109 15.9983 9.00061 15.6155 9.00061L4.69472 9.00061C4.31216 9.00061 4.00167 9.3111 4.00167 9.69366C4.00167 10.0762 4.31216 10.3867 4.69472 10.3867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0586 4.55527L11.0586 2.75C11.0586 2.33579 10.7228 2 10.3086 2C9.89438 2 9.55859 2.33579 9.55859 2.75L9.55859 4.55527L7.30859 4.55527L10.3086 7.54777L13.3086 4.55527L11.0586 4.55527Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 15.4447L9.55859 17.25C9.55859 17.6642 9.89438 18 10.3086 18C10.7228 18 11.0586 17.6642 11.0586 17.25L11.0586 15.4447L13.3086 15.4447L10.3086 12.4522L7.30859 15.4447L9.55859 15.4447Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMiddle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/middle.97a5b641.svg";
export { ForwardRef as ReactComponent };